<template>
  <div class="editbox" v-show="show">
  <infoSlider :style="{zIndex: 1000}" :show="show" :label="'編輯類別'" :width="481" :icon="'partner'" @close="$emit('close')">
    <div class="cateEditContainer">
    <RT :options="['新增', '編輯']" :defaultValue="page" @input="page=$event"></RT>
    <draggable v-model="cates" class="cates">
      <div draggable v-for="(cate, c) in cates" class="cate" :key="`cate-${c}`" :style="{color:cate.color, borderColor:cate.color}">{{cate.name}}
        <span :style="{backgroundColor:cate.color}"><button v-if="page==='編輯'" class="deleteBtn" @click="cates.splice(c, 1);changed=true"/></span>

      </div>
    </draggable>
    <div class="cates" v-if="page==='新增'">
      <div class="cate" :style="{color:color, borderColor:color}">
        <Input :center="true" :placeholder="'請輸入新類別'" :style="{height:'37px', border:'none'}" :defaultValue="name" @input="name=$event"/>
        <span @click="edit=true" :style="{backgroundColor:color}"></span>

      </div>
      <ColorPicker type="linear" v-model="edit" class="ColorPicker" :style="{zIndex: 1000, marginInline: 'auto'}"
        @changeColor="changeColor" :titleConfig="titleConfig"
        @onClose="edit=false"
        :pDeg="90"
        :pColor="pColor"
        :showClose="true"
        :closeOnClickBody="false"/>
      <BtnsS @save="push" :save="'新增'" @cancel="name=null;"/>
    </div>
    <div v-else>
      <BtnsS v-if="changed" @save="save" :save="'儲存'" @cancel="reset"/>
    </div>
    </div>
  </infoSlider>
</div>
</template>

<script>
import draggable from 'vuedraggable'
import Input from '../../components/input/normal.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import ColorPicker from 'vue2-color-picker-gradient'
import { postapi } from '../../store/fetch'
export default {
  props: ['show', 'categories'],
  components: { infoSlider, draggable, Input, ColorPicker },
  data () {
    return {
      changed: false,
      page: '新增',
      cates: [],
      color: '#CACACA',
      name: null,
      edit: false,
      CA: {
        hex: '#CACACA',
        hex8: '#CACACA',
        hsl: { h: 0, s: 0, l: 0.79, a: 1 },
        hsv: { h: 0, s: 0, v: 0.79, a: 1 },
        rgba: { r: 202, g: 202, b: 202, a: 1 },
        a: 1,
        color: 'rgba(202,202,202,1)'
      },
      pColor: {
        hex: '#CACACA',
        hex8: '#CACACA',
        hsl: { h: 0, s: 0, l: 0.79, a: 1 },
        hsv: { h: 0, s: 0, v: 0.79, a: 1 },
        rgba: { r: 202, g: 202, b: 202, a: 1 },
        a: 1,
        color: 'rgba(202,202,202,1)'
      },
      titleConfig: {
        show: true,
        text: '請選擇顏色'
      },
      pDeg: 60
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.edit = null
      }
    },
    categories: {
      immediate: true,
      handler () {
        this.cates = JSON.parse(JSON.stringify(this.categories))
      }
    }
  },
  mounted () {
    this.cates = JSON.parse(JSON.stringify(this.categories))
  },
  methods: {
    reset () {
      this.cates = JSON.parse(JSON.stringify(this.categories))
    },
    async save () {
      const r = await postapi('selections/partnerCategories', { data: this.cates })
      if (r) {
        this.cates = r
        this.name = null
        this.color = '#CACACA'
        this.pColor = this.CA
        this.$emit('cates', r)
        this.changed = false
      }
    },
    async push () {
      if (!this.name) {
        return false
      }
      const r = await postapi('selections/push/partnerCategories', { name: this.name, color: this.color })
      if (r) {
        this.cates = r
        this.name = null
        this.color = '#CACACA'
        this.pColor = this.CA
        this.$emit('cates', r)
      }
    },
    changeColor ({ color }) {
      this.color = color.hex
    }
  }

}
</script>

<style lang="scss" scoped>
.cateEditContainer {
  padding: 20px;
}
.cates {
  display: flex;
  flex-direction: column;
  height: fit-content;
  gap: 10px;
  padding: 20px;
}
.cate {
  height: 40px;
  display: grid;
  align-items: center;
  grid-template-columns:  1fr 60px;
  font-size: 24px;
  border: 1px solid;
  span {
    width: 60px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .deleteBtn {
      background-color: #FFFFFF;
      mask-image: url(/svg/btn/del1.svg);
      mask-repeat: no-repeat;
      mask-size: contain;
      mask-position: center;
      width: 26px;
      height: 26px;
    }
  }
}
.editbox {
  position: fixed;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
</style>
